module.exports = __webpack_public_path__ + "static/media/peeps.41e3dd9c.png";